import { motion } from 'framer-motion';
import { keyedList } from '@/lib/keys';

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05 } },
};
const wordVariant = {
  hidden: { y: '100%' },
  visible: { y: '0%', transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] } },
};

// Splits `text` into words and reveals them with a staggered upward mask
// animation, triggered once when scrolled into view. Ideal for hero headlines.
export const TextReveal = ({ text, className = '', delay = 0, once = true }) => {
  const words = String(text).split(' ');
  return (
    <motion.span
      className={`inline-block ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once }}
      variants={container}
      transition={{ delayChildren: delay }}
    >
      {keyedList(words).map(({ key, item: word }) => (
        <span key={key} className="inline-block overflow-hidden pb-[0.08em] mr-[0.22em] last:mr-0 align-top">
          <motion.span className="inline-block" variants={wordVariant}>
            {word}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
